<template>
  <div class="file">
    <div class="file__icon">
      <IconFile />
      <span class="file__extension">{{ extension }}</span>
    </div>

    <a
      :href="url"
      target="_blank"
      class="file__link"
      :title="file.name"
      :download="file.name"
    >
      {{ filteredName }}
    </a>

    <span class="file__size" :class="isDisabled && 'file__size--mr-0'">
      {{ fileSize }}
    </span>

    <div
      v-if="!isDisabled"
      class="file__actions d-flex ai-c gap-30"
    >
      <button
        type="button"
        class="file__btn-delete btn-cross"
        @click="deleteFile"
      />

      <div class="file__grab"><div/></div>
    </div>
  </div>
</template>

<script>
import { sliceString } from '@/utils/string/sliceString'
import { fixedFileSize } from '@/utils/string/fixedFileSize'
import IconFile from '@/components/Icons/IconFile.vue'
import { getFileName, getFileSize, getFileURL } from '@/utils/file'

export default {
  name: 'FileListItem',
  components: { IconFile },
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    file: {
      type: [Object, File],
      require: true
    },
    maxLength: {
      type: Number,
      default: 65
    }
  },

  computed: {
    filteredName () {
      return sliceString(this.fileName, this.maxLength)
    },
    fileName () {
      return getFileName(this.file)
    },
    fileSize () {
      return fixedFileSize(getFileSize(this.file))
    },
    url () {
      return getFileURL(this.file)
    },
    extension () {
      return this.fileName?.split('.')?.at(-1).toUpperCase() || ''
    }
  },

  methods: {
    deleteFile () {
      this.$emit('delete-file', this.file)
    }
  }
}
</script>

<style lang="scss">
.file {
  display: flex;
  align-items: center;
  width: 100%;

  &__icon {
    position: relative;
    margin-right: 20px;
    width: 34px;
    height: 40px;

    svg {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }

  &__extension {
    position: absolute;
    left: 50%;
    bottom: 5px;
    transform: translateX(-50%);
    font-family: $font_main;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0;
    color: $color_info;
  }

  &__size {
    color: #cbcbcb;
    font-size: 16px;
    line-height: 24px;
    margin-left: auto;
    margin-right: 70px;
    color: $color_info;

    &--mr-0 {
      margin-right: 0;
    }
  }

  &__link {
    margin-right: 70px;
    font-size: 16px;
    line-height: 24px;
    white-space: nowrap;
    color: $font_color_second;
  }

  &__btn-delete {
    position: relative;
    width: 20px;
    height: 20px;

    &::before,
    &::after {
      width: 100%;
      background: $color_deactive;
    }
  }

  &__grab {
    --size: 5px;
    --bg: #D9D9D9;
    --position: 13px;

    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 1px;
    background-color: #F4F6FC;
    cursor: grab;

    &::before,
    &::after,
    div::before,
    div::after {
      content: '';
      position: absolute;
      width: var(--size);
      height: var(--size);
      background-color: var(--bg);
    }

    &::before {
      top: var(--position);
      left: var(--position);
    }

    &::after {
      top: var(--position);
      right: var(--position);
    }

    div::before {
      bottom: var(--position);
      left: var(--position);
    }

    div::after {
      bottom: var(--position);
      right: var(--position);
    }
  }
}
</style>
